import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ElectricityPricing from './components/ElectricityPricing';
import TomorrowPrices from './components/TomorrowPrices';
import NorwegianElectricityPricing from './components/NorwegianElectricityPricing';
import DanishElectricityPricing from './components/DanishElectricityPricing';
import HistoricalPricing from './components/HistoricalPricing';
import KildenKraftPricing from './components/KildenKraftPricing';
import CheapenergyPricing from './components/CheapenergyPricing';
import CheapDenmarkPricing from './components/CheapDenmarkPricing';
import CheapSwedenPricing from './components/CheapSwedenPricing';
import BaerumPricing from './components/BaerumPricing';
import ElectricityPricingSE1 from './components/ElectricityPricingSE1';
import ElectricityPricingSE2 from './components/ElectricityPricingSE2';
import ElectricityPricingSE3 from './components/ElectricityPricingSE3';
import ElectricityPricingSE4 from './components/ElectricityPricingSE4';
import MotalaPricing from './components/MotalaPricing';
import ActualGenerationDashboard from './components/ActualGenerationDashboard';
import LoadDashboard from './components/LoadDashboard';
import NetPositionsDashboard from './components/NetPositionsDashboard';
import TransmissionFlowsDashboard from './components/TransmissionFlowsDashboard';
import AIForecastDashboard from './components/AIForecastDashboard';
import SmartScheduler from './components/SmartScheduler';
import './App.css';

const App = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-900 via-black to-gray-900">
            <Routes>
                <Route path="/" element={<ElectricityPricing />} />
                <Route path="/imorgon" element={<TomorrowPrices />} />
                <Route path="/norwegian-prices" element={<NorwegianElectricityPricing />} />
                <Route path="/danish-prices" element={<DanishElectricityPricing />} />
                <Route path="/history" element={<HistoricalPricing />} />
                <Route path="/kilden-kraft" element={<KildenKraftPricing />} />
                <Route path="/cheapenergy" element={<CheapenergyPricing />} />
                <Route path="/cheapenergy-denmark" element={<CheapDenmarkPricing />} />
                <Route path="/cheapenergy-sweden" element={<CheapSwedenPricing />} />
                <Route path="/baerum" element={<BaerumPricing />} />
                <Route path="/se1" element={<ElectricityPricingSE1 />} />
                <Route path="/se2" element={<ElectricityPricingSE2 />} />
                <Route path="/se3" element={<ElectricityPricingSE3 />} />
                <Route path="/se4" element={<ElectricityPricingSE4 />} />
                <Route path="/motala" element={<MotalaPricing />} />
                <Route path="/generation" element={<ActualGenerationDashboard />} />
                <Route path="/load" element={<LoadDashboard />} />
                <Route path="/net-positions" element={<NetPositionsDashboard />} />
                <Route path="/transmission" element={<TransmissionFlowsDashboard />} />
                <Route path="/ai-forecast" element={<AIForecastDashboard />} />
                <Route path="/smart-scheduler" element={<SmartScheduler />} />
            </Routes>
        </div>
    );
};

export default App;
